import {csrfHeader} from "./lib/utils";

document.addEventListener('DOMContentLoaded', () => {
    const fileInput = document.getElementById('file');
    if (fileInput) {
        fileInput.addEventListener('change', () => {
            const files = fileInput.files;
            handleFile(files[0]);
            fileInput.value = '';
        });
    }
});

const handleFile = (file) => {
    const headers = csrfHeader();
    const body = new FormData();
    body.append('csv', file);
    window.setGrid([]);
    fetch('/deliveries/csv', {method: 'POST', body, headers}).then(res => res.json()).then((res) => {
        window.setGrid(res.csv);
    }).catch((err) => {
        console.error(err);
    });
};